import { InfoCircleOutlined } from '@ant-design/icons';
import { Col, Row, Tooltip } from 'antd';

import { ISnapStore, selectEligibleProductIdentityAction } from 'containers/Snaps/Snap/store';

import { ProductLineItemMatch } from 'codegen';
import {
  InitialTableActions,
  TColumn,
  TEditableColumn,
  TFieldProps,
} from 'types';

export const columns = ({
  lineItemOptions,
  eligibleProductOptions,
  productIdentitiesOptions,
}: {
  lineItemOptions?: ISnapStore['lineItemOptions'],
  eligibleProductOptions?: ISnapStore['eligibleProductOptions'],
  productIdentitiesOptions?: ISnapStore['productIdentitiesOptions'],
}): TEditableColumn<ProductLineItemMatch>[] => [{
  width: 250,
  title: 'Line Item',
  dataIndex: 'lineItem',
  field: {
    type: TFieldProps.type.Select,
    options: lineItemOptions,
    allowClear: false,
    optionRender: (option) => {
      if (!option.data.total) {
        return (
          <button disabled className='opacity-20'>
            <Tooltip title='This items has no total value'>
              <InfoCircleOutlined className='mr-1' />
            </Tooltip>

            {option.label}
          </button>
        );
      }

      return option.label;
    },
    rules: [{
      message: 'Item Name is required',
      required: true,
    }],
  },
  render: (value, { hasConflict, isMarkedForDeletion }) => (
    <Row wrap={false} gutter={5}>
      <Col>
        {isMarkedForDeletion && (
          <Tooltip title='This items is marked for deletion'>
            <InfoCircleOutlined className='text-[#FF0000]' />
          </Tooltip>
        )}

        {hasConflict && (
          <Tooltip title='This match conflicts with another(same line item is matched more than once)'>
            <InfoCircleOutlined className='text-[#FAAD14]' />
          </Tooltip>
        )}
      </Col>

      <Col flex={1}>
        <Tooltip placement='bottomLeft' title={value.label}>
          <p className='truncate mb-0'>
            {value.label}
          </p>
        </Tooltip>
      </Col>
    </Row>
  ),
}, {
  type: TColumn.type.Ellipsis,
  width: 250,
  title: 'Matched Product',
  dataIndex: 'matchedProduct',
  field: {
    type: TFieldProps.type.Select,
    options: eligibleProductOptions,
    allowClear: false,
    onSelectChange: selectEligibleProductIdentityAction,
    rules: [{
      message: 'Matched Product is required',
      required: true,
    }],
  },
}, {
  type: TColumn.type.Tags,
  width: 250,
  title: 'Matched By',
  dataIndex: 'matchedByIdentities',
  field: {
    type: TFieldProps.type.Select,
    options: productIdentitiesOptions,
    allowClear: false,
    rules: [{
      message: 'Matched By is required',
      required: true,
    }],
  },
}, {
  width: 100,
  title: 'Quantity',
  dataIndex: 'quantity',
}, {
  type: TColumn.type.Status,
  width: 180,
  title: 'Status',
  dataIndex: 'status',
}, {
  type: TColumn.type.Percent,
  width: 120,
  title: 'Matching Score',
  dataIndex: 'matchScore',
}, {
  type: TColumn.type.Checkbox,
  width: 110,
  title: 'Processed',
  dataIndex: 'isTransactionCreated',
}];

export const initialTableActions = [{
  type: InitialTableActions.Edit,
}, {
  type: InitialTableActions.Approve,
}, {
  type: InitialTableActions.Delete,
}];
